import { Box } from "@mui/material";
import { MotifGlyph, type MotifGlyphKind } from "./MotifGlyph";

export const MotifBadge = ({
  kind,
  label,
  color,
  title,
}: {
  kind: MotifGlyphKind;
  label: string;
  color: string;
  title?: string;
}) => (
  <Box
    data-motif-badge
    role={title ? "img" : undefined}
    aria-label={title}
    title={title}
    sx={{
      width: "100%",
      height: "100%",
      borderRadius: 0,
      bgcolor: "#0a0a0a",
      color: "#f0ece2",
      border: "2px solid #f0ece2",
      boxShadow: `2px 2px 0 ${color}`,
      boxSizing: "border-box",
      display: "grid",
      placeItems: "center",
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "clamp(.56rem,1.5vw,.76rem)",
      fontWeight: 900,
      letterSpacing: "-.08em",
      lineHeight: 1,
    }}
  >
    <MotifGlyph kind={kind} label={label} />
  </Box>
);
